import React from "react";
import PropTypes from "prop-types";
import "./_assetGrid.scss";

// Defaults as parameters: React 19 ignores defaultProps on function components
// (an undefined cellSize gave `--cmp-cell-size: undefinedpx` → tiles sized by content).
const AssetGrid = ({ cellSize = 84, columns, gap = 10, children }) => {
  const style = { "--cmp-cell-size": `${cellSize}px`, "--cmp-grid-gap": `${gap}px` };
  if (columns) style.gridTemplateColumns = `repeat(${columns}, minmax(0, 1fr))`;

  return (
    <div className="cmp-grid" style={style}>
      {children}
    </div>
  );
};

AssetGrid.propTypes = {
  cellSize: PropTypes.number,
  columns: PropTypes.number,
  gap: PropTypes.number,
  children: PropTypes.node,
};

export default AssetGrid;
